<ui-object-navigation-main-page alias="as"></ui-object-navigation-main-page>